// Firebase プロジェクト設定 (環境変数から取得)
// CRA 環境では REACT_APP_ プレフィックスが必要

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// --- Runtime Config Strategy ---
// 1) configureFirebase({...}) をアプリ起動前に呼び出し（推奨）
// 2) window.__FIREBASE_CONFIG__ に設定を埋め込む (index.html で <script> の前に)
// 3) 上記が無い場合のみ REACT_APP_ 環境変数からフォールバック (ローカル開発向け)

let injectedConfig = null; // configureFirebase で設定される

export function configureFirebase(config) {
  injectedConfig = { ...config };
}

function buildConfig() {
  if (injectedConfig) return injectedConfig;
  if (typeof window !== 'undefined' && window.__FIREBASE_CONFIG__) {
    injectedConfig = { ...window.__FIREBASE_CONFIG__ };
    return injectedConfig;
  }
  // fallback to env (development convenience)
  const envConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };
  injectedConfig = envConfig; // キャッシュ
  return injectedConfig;
}

function assertConfig(cfg) {
  const required = ['apiKey','authDomain','projectId','appId'];
  const missing = required.filter(k => !cfg || !cfg[k]);
  if (missing.length) {
    throw new Error('[firebaseConfig] Firebase設定が不足: ' + missing.join(', ') + '\nconfigureFirebase({...}) で設定を注入してください。');
  }
}

// Lazy 初期化 (HMR や循環参照での TDZ 回避)
let appInstance; // Firebase App (singleton)
let authInstance; // Auth (singleton)

export function getFirebaseApp() {
  if (!appInstance) {
    const cfg = buildConfig();
    assertConfig(cfg);
    appInstance = initializeApp(cfg);
  }
  return appInstance;
}

export function getFirebaseAuth() {
  if (!authInstance) {
    authInstance = getAuth(getFirebaseApp());
  }
  return authInstance;
}

// 設定が揃っているか (例: UI 側で機能出し分け用)
export function hasFirebaseConfig() {
  try {
    const cfg = buildConfig();
    return ['apiKey','authDomain','projectId','appId'].every(k => cfg && cfg[k]);
  } catch (e) {
    return false;
  }
}
